/* global axios */
import ApiClient from '../ApiClient';

class AssistantResponses extends ApiClient {
  constructor() {
    super('assistant/responses', { accountScoped: true });
  }

  get({
    page = 1,
    searchKey,
    assistantId,
    knowledgeBaseId,
    documentId,
    status,
  } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search_key: searchKey,
        assistant_id: assistantId,
        knowledge_base_id: knowledgeBaseId,
        document_id: documentId,
        status,
      },
    });
  }

  create(data = {}) {
    return axios.post(this.url, { response: data });
  }

  update(id, data = {}) {
    return axios.patch(`${this.url}/${id}`, { response: data });
  }
}

export default new AssistantResponses();
